<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>{{ titleForm }}</span></li>
            </ol>
        </div>
        <div class="card mt-5" v-loading="loading">
            <div class="card-header bg-info">
                <h3 class="my-0">{{ titleForm }}</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <x-switch-left label="Habilitar sincronizar datos"
                                       v-model="form.enable_sync_data"></x-switch-left>
                    </div>
                    <div class="col-12">
                        <x-input label="Data de origen" v-model="form.data_origin"></x-input>
                    </div>
                    <div class="col-12">
                        <x-input label="Token de origen" v-model="form.token_origin"></x-input>
                    </div>
                    <div class="col-12 text-right" style="margin-top: 24px">
                        <x-button-submit text="Actualizar" @click="onSubmit"></x-button-submit>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-5" v-loading="loadingActions" v-if="form.enable_sync_data">
            <div class="card-header bg-info">
                <h3 class="my-0">Acciones de sincronización</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col text-center">
                        <x-button-cancel text="Eliminar datos"
                                         :loading="loadingTruncate"
                                         @click="clickTruncate"></x-button-cancel>
                    </div>
                    <div class="col text-center">
                        <x-button-primary text="Actualizar datos"
                                         :loading="loadingUpdateData"
                                         @click="clickUpdateData"></x-button-primary>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label>Desde</label>
                        <el-date-picker v-model="dateStart"
                                        value-format="yyyy-MM-dd"
                                        format="dd/MM/yyyy"
                                        :clearable="false"></el-date-picker>
                    </div>
                    <div class="col text-center">
                        <x-button-primary text="Actualizar documentos"
                                          :loading="loadingUpdateDocument"
                                          @click="clickUpdateDocument"></x-button-primary>
                    </div>
                </div>
<!--                <div class="row">-->
<!--                    <div class="col-12">-->
<!--                        <el-button type="primary" :loading="loadingSubmit" @click.prevent="clickDownload">-->
<!--                            <template v-if="loadingSubmit">-->
<!--                                Generando...-->
<!--                            </template>-->
<!--                            <template v-else>-->
<!--                                Generar-->
<!--                            </template>-->
<!--                        </el-button>-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                        <label>Periodo</label>-->
<!--                        <el-date-picker v-model="form.month" type="month"-->
<!--                                        value-format="yyyy-MM" format="MM/yyyy" :clearable="false"></el-date-picker>-->
<!--                    </div>-->
<!--                    <div class="col-md-8">-->
<!--                        <label>Formato</label>-->
<!--                        <el-select v-model="form.format">-->
<!--                            &lt;!&ndash;                            <el-option key="format_warehouse_purchase" value="format_warehouse_purchase" label="ALMACEN - COMPRAS"></el-option>&ndash;&gt;-->
<!--                            <el-option key="format_incomes" value="format_incomes" label="INGRESOS"></el-option>-->
<!--                            <el-option key="format_warehouse_purchase" value="format_warehouse_purchase" label="ALMACEN - COMPRAS"></el-option>-->
<!--                            &lt;!&ndash;                            <el-option key="format_cost_sale" value="format_cost_sale" label="COSTO DE VENTAS"></el-option>&ndash;&gt;-->
<!--                        </el-select>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import XInput from "../../../../components/Form/XInput.vue";
import XSwitchLeft from "../../../../components/Form/XSwitchLeft.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";

export default {
    name: 'SynchronizeData',
    components: {XButtonCancel, XButtonPrimary, XButtonSubmit, XSwitchLeft, XInput},
    data() {
        return {
            loading: false,
            loadingSubmit: false,
            loadingActions: false,
            loadingTruncate: false,
            loadingUpdateData: false,
            loadingUpdateDocument: false,
            titleForm: null,
            title: null,
            resource: 'configurations/synchronize_data',
            error: {},
            form: {},
            dateStart: null
        }
    },
    async created() {
        this.initForm();
        this.titleForm = 'Sincronizar Datos';
        await this.$http
            .get(`/${this.resource}/record`)
            .then((response) => {
                this.form = Object.assign({}, this.form, response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                enable_sync_data: false,
                data_origin: null,
                token_origin: null
            }
            this.dateStart = moment().format('YYYY-MM-DD')
        },
        // clickDownload() {
        //     this.loadingSubmit = true;
        //     let query = queryString.stringify({
        //         ...this.form
        //     });
        //     window.open(`/${this.resource}/download?${query}`, '_blank');
        //     this.loadingSubmit = false;
        // },
        onSubmit() {
            if (this.form.enable_sync_data) {
                if (this.form.data_origin === '' || this.form.data_origin === null) {
                    this.$message.error('El campo data de origen es requerido')
                    return
                }
                if (this.form.token_origin === '' || this.form.token_origin === null) {
                    this.$message.error('El campo token de origen es requerido')
                    return
                }
            } else {
                this.form.data_origin = null
                this.form.token_origin = null
            }

            this.loading = true
            this.loadingSubmit = true
            this.$http
                .post(`/${this.resource}`, this.form)
                .then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    this.loadingSubmit = false
                    this.loading = false
                })
        },
        clickTruncate() {
            this.loadingActions = true
            this.loadingTruncate = true
            this.$http
                .get(`/${this.resource}/truncate`)
                .then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    this.loadingTruncate = false
                    this.loadingActions = false
                })
        },
        clickUpdateData() {
            this.loadingActions = true
            this.loadingUpdateData = true
            this.$http
                .get(`/${this.resource}/init_tables`)
                .then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    this.loadingUpdateData = false
                    this.loadingActions = false
                })
        },
        clickUpdateDocument() {
            this.loadingActions = true
            this.loadingUpdateDocument = true
            this.$http
                .post(`/${this.resource}/update_documents`, {
                    'date_start': this.dateStart
                })
                .then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    this.loadingUpdateDocument = false
                    this.loadingActions = false
                })
        }
    }
}
</script>
